import './thehiddentable/style';
import FormStructure from './thehiddentable/form_structure';

export default FormStructure;